function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon Design - Merged Final"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.259 11.86a7.867 7.867 0 00-2.89-9.532 1.516 1.516 0 00-2.786-1.165A7.864 7.864 0 006.75 5.85L5.269 9.426a4.29 4.29 0 01-1.332 1.743l-1.903 1.474a2.666 2.666 0 00.612 4.57l5.392 2.234a4 4 0 007.155 2.964l.932.386a2.665 2.665 0 003.484-1.445 2.684 2.684 0 00.181-1.355l-.304-2.388a4.27 4.27 0 01.291-2.172zM12 22a2.003 2.003 0 01-1.982-1.733l3.196 1.324A1.997 1.997 0 0112 22zm7.411-10.905L17.93 14.67a6.283 6.283 0 00-.428 3.19l.304 2.386a.675.675 0 01-.045.34.668.668 0 01-.87.362L3.412 15.366a.666.666 0 01-.153-1.142l1.903-1.474a6.282 6.282 0 001.954-2.558l1.482-3.577a5.852 5.852 0 0110.813 4.48z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  opacity: ".5",
  d: "M0 0h24v24H0z"
})));